export const last = (arr) => arr[arr.length - 1];
export const EMPTY_ARR = [];
